export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '移动追剧', href: '#app' },
  { label: '热门话题', href: '#topics' },
  { label: '热播排行', href: '#ranking' },
  { label: '关于7788电影网', href: '#about' },
];

export const heroData = {
  tag: '全网热播剧集 · 每日更新',
  h1: '7788电影网 · 高清追剧不缓冲',
  slogan: '万部剧集，一网打尽',
  description: '7788电影网汇聚全网最新、最热的电视剧资源，涵盖古装仙侠、都市情感、悬疑推理、青春校园等全品类剧集。每日同步更新，高清画质流畅播放，无需等待缓冲，为您打造沉浸式追剧体验。无论您是偏爱经典老剧还是追逐新番热剧，这里都是您的追剧首选平台。',
  stats: [
    { value: '10万+', label: '剧集资源' },
    { value: '每日更新', label: '50+ 部新剧' },
    { value: '99.9%', label: '播放流畅率' },
  ],
  primaryCta: { label: '开始追剧', href: '#index' },
  secondaryCta: { label: '热门榜单', href: '#ranking' },
};

export const indexItems = [
  {
    title: '古装仙侠',
    description: '梦回千年，仙侠世界里的爱恨情仇与快意恩仇，每一帧都是绝美画卷。',
    tag: '热播',
    icon: 'ri-sword-line',
  },
  {
    title: '都市情感',
    description: '繁华都市中的温暖故事与人生百态，直击心灵的情感共鸣。',
    tag: '推荐',
    icon: 'ri-building-2-line',
  },
  {
    title: '悬疑推理',
    description: '烧脑剧情层层推进，在迷雾中抽丝剥茧寻找真相，全程高能。',
    tag: '新番',
    icon: 'ri-search-eye-line',
  },
  {
    title: '青春校园',
    description: '青涩年华里的成长与梦想，那些年我们一起追过的青春故事。',
    tag: '热门',
    icon: 'ri-book-open-line',
  },
  {
    title: '历史传奇',
    description: '穿越时空长河，见证历史风云变幻，感受英雄人物的传奇人生。',
    tag: '经典',
    icon: 'ri-ancient-gate-line',
  },
  {
    title: '科幻奇幻',
    description: '突破想象边界，探索未知世界的无限可能，视觉特效震撼人心。',
    tag: '新番',
    icon: 'ri-rocket-line',
  },
  {
    title: '家庭伦理',
    description: '柴米油盐中的温情与感动，平凡生活里最真挚的人间烟火。',
    tag: '暖心',
    icon: 'ri-home-heart-line',
  },
];

export const mediaItems = [
  {
    title: '长安十二时辰',
    subtitle: '古装悬疑巨制',
    description: '大唐天宝三载，上元节前夕，长安城陷入前所未有的危机之中……',
    tag: '9.6分',
  },
  {
    title: '你比星光美丽',
    subtitle: '都市爱情剧',
    description: '两个灵魂在繁华都市中相遇，彼此治愈、共同成长的故事。',
    tag: '9.4分',
  },
  {
    title: '深渊行者',
    subtitle: '悬疑推理剧',
    description: '一桩尘封十年的悬案被重新揭开，真相比深渊更加令人不寒而栗。',
    tag: '9.5分',
  },
  {
    title: '那年夏天有风吹过',
    subtitle: '青春校园剧',
    description: '高中三年，关于友情、梦想和初恋的青涩记忆，永远闪闪发光。',
    tag: '9.2分',
  },
  {
    title: '山河令之龙渊',
    subtitle: '武侠奇幻剧',
    description: '江湖风云再起，少年背负天命，踏上寻找失落神器龙渊的征途。',
    tag: '9.3分',
  },
];

export const contactData = {
  title: '剧集投稿与商务合作',
  description: '如果您有好剧推荐、内容投稿意向或商务合作需求，欢迎通过以下方式与我们取得联系。7788电影网期待与更多优质内容创作者和合作伙伴携手，共同为广大追剧爱好者带来更丰富、更高品质的电视剧观看体验。',
  email: 'contact@7788movie.com',
  wechat: '7788movie_wx',
};

export const carouselItems = [
  {
    title: '长安十二时辰',
    subtitle: '古装悬疑巅峰之作 · 9.6分',
    description: '大唐天宝三载，上元节前夕，长安城陷入前所未有的危机。死囚张小敬临危受命，与少年名士李必携手，在十二时辰内拯救这座伟大的城市。精良制作、悬疑迭起，每一帧都如画卷般精美。',
    tag: '年度必看',
  },
  {
    title: '你比星光美丽',
    subtitle: '都市情感暖心剧 · 9.4分',
    description: '两个看似毫无交集的人，在命运的安排下相遇、相知、相爱。职场的纷争、生活的琐碎、成长的迷茫，在这座不眠的城市里，他们彼此治愈，共同找寻属于自己的星光。',
    tag: '催泪推荐',
  },
  {
    title: '深渊行者',
    subtitle: '悬疑推理烧脑剧 · 9.5分',
    description: '十年前的连环案件尘封未解，十年后同样的作案手法再次出现。资深刑警与犯罪心理学家联手追凶，却发现真相远比想象中更加残酷。全程高能反转，不到最后一秒猜不到结局。',
    tag: '高能预警',
  },
  {
    title: '那年夏天有风吹过',
    subtitle: '青春校园温情剧 · 9.2分',
    description: '那个夏天，蝉鸣、单车、篮球场，还有偷偷藏在课本下的情书。林知夏和一群好友度过了最灿烂的高中三年，关于友情、梦想和初恋的故事，让无数观众泪目。',
    tag: '回忆杀',
  },
  {
    title: '山河令之龙渊',
    subtitle: '武侠奇幻史诗剧 · 9.3分',
    description: '上古神器龙渊重现人间，引发天下群雄逐鹿。少年剑客谢云归背负师门遗命，踏遍九州山河，在追寻龙渊的旅途中逐渐揭开了自己身世的惊天秘密。',
    tag: '口碑爆款',
  },
  {
    title: '苍穹之下',
    subtitle: '科幻悬疑大剧 · 9.1分',
    description: '一场突如其来的全球性停电让人类社会陷入混乱。物理学家陈默发现，这并非天灾，而是一场精心策划的巨大阴谋。当真相浮出水面，人类的命运将何去何从？',
    tag: '脑洞大开',
  },
];

export const commentItems = [
  {
    author: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20minimalist%20portrait%20photography%2C%20neutral%20warm%20background%2C%20casual%20elegant%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '7788电影网的画质真的太赞了！看《长安十二时辰》完全不用等缓冲，每一帧都清晰到可以当壁纸。追剧体验秒杀其他平台，已经推荐给身边所有朋友了。',
    drama: '长安十二时辰',
    time: '2小时前',
  },
  {
    author: '夜深人不静',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20with%20gentle%20expression%2C%20warm%20studio%20lighting%2C%20minimalist%20portrait%20photography%2C%20neutral%20warm%20background%2C%20casual%20professional%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '作为一个悬疑剧爱好者，《深渊行者》的剧情真的让我头皮发麻！每集结尾都有反转，根本停不下来。更新速度也很快，不用煎熬等更新。',
    drama: '深渊行者',
    time: '5小时前',
  },
  {
    author: '春日迟迟',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20warm%20gentle%20smile%2C%20soft%20golden%20lighting%2C%20minimalist%20portrait%20photography%2C%20neutral%20warm%20background%2C%20casual%20cozy%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '《你比星光美丽》看得我哭了三次！演技、剧情、画面都在线，男女主的CP感太强了。感谢7788电影网让我找到这么好的剧，已经二刷了。',
    drama: '你比星光美丽',
    time: '1天前',
  },
  {
    author: '老张说剧',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20man%20portrait%20with%20warm%20confident%20expression%2C%20soft%20studio%20lighting%2C%20minimalist%20portrait%20photography%2C%20neutral%20warm%20background%2C%20casual%20intellectual%20style&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: '片库真的很全！好多老剧在其他平台都下架了，在7788还能找到高清版本。分类也很清晰，找剧很方便。希望继续保持，会一直支持的。',
    drama: '平台整体体验',
    time: '2天前',
  },
  {
    author: '星辰大海',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20bright%20smile%2C%20soft%20natural%20lighting%2C%20minimalist%20portrait%20photography%2C%20neutral%20warm%20background%2C%20casual%20fresh%20style&width=120&height=120&seq=avatar-05&orientation=squarish',
    content: '《山河令之龙渊》的特效太震撼了，完全不输院线大片！剧情紧凑不拖沓，演员打戏也很精彩。7788电影网的片源质量真的没话说。',
    drama: '山河令之龙渊',
    time: '3天前',
  },
];

export const topicItems = [
  { name: '长安十二时辰大结局', heat: '128万热议', tag: '爆' },
  { name: '古装剧天花板', heat: '96万热议', tag: '热' },
  { name: '悬疑剧推荐清单', heat: '87万热议', tag: '热' },
  { name: '你比星光美丽CP感', heat: '73万热议', tag: '新' },
  { name: '深渊行者凶手是谁', heat: '65万热议', tag: '新' },
  { name: '暑期追剧指南', heat: '58万热议', tag: '' },
  { name: '青春校园剧盘点', heat: '52万热议', tag: '' },
  { name: '国产剧年度十佳', heat: '47万热议', tag: '' },
  { name: '武侠剧文艺复兴', heat: '41万热议', tag: '' },
  { name: '苍穹之下世界观', heat: '36万热议', tag: '' },
];

export const appData = {
  title: '随时随地，追剧不停',
  description: '下载7788电影网移动客户端，无论在地铁上、午休时还是旅途中，都能畅享高清流畅的追剧体验。支持离线下载、夜间模式、倍速播放，让好剧时刻相伴。',
  features: [
    '高清流畅播放',
    '离线下载随时看',
    '夜间护眼模式',
    '智能追剧提醒',
  ],
};

export const aboutData = {
  title: '7788电影网 · 用心做好追剧这件事',
  description1: '7788电影网成立于2019年，始终致力于为广大追剧爱好者提供最全面、最高清、最流畅的电视剧在线观看服务。经过多年积累，我们已建成涵盖古装、都市、悬疑、青春、历史、科幻、家庭等全品类剧集的海量片库，资源总量超过10万部。',
  description2: '我们深知追剧体验的重要性——高清画质是基础，流畅播放是底线。7788电影网采用先进的视频压缩与CDN加速技术，确保每部剧集都能以最佳画质稳定播放，告别卡顿和缓冲的烦恼。同时，我们保持每日更新节奏，让您不错过任何一部好剧。',
  description3: '未来，7788电影网将继续深耕内容领域，拓展更多优质剧集资源，优化播放技术，为用户提供更加极致的追剧体验。追剧这件事，我们是认真的。',
};

export const updateItems = [
  {
    date: '2026.07.30',
    title: '《长安十二时辰》全集上线，4K修复版同步放送',
    content: '备受瞩目的古装悬疑巨制《长安十二时辰》全集已正式上线，同步推出4K修复版。该剧以精良的制作和扣人心弦的剧情获得9.6高分评价。',
  },
  {
    date: '2026.07.25',
    title: '夏季追剧专题「燃夏剧场」正式上线',
    content: '7788电影网推出夏季特别专题「燃夏剧场」，精选50部高分热剧，涵盖悬疑、动作、奇幻等多种类型，陪你度过炎炎夏日。',
  },
  {
    date: '2026.07.18',
    title: '播放器全面升级，新增智能续播与画质增强功能',
    content: '新版播放器上线智能续播功能，自动记忆观看进度。同时画质增强引擎上线，低分辨率片源也能获得接近高清的观看体验。',
  },
  {
    date: '2026.07.10',
    title: '《深渊行者》播放量突破5亿，全网热议',
    content: '悬疑推理剧《深渊行者》自上线以来持续霸榜，凭借环环相扣的剧情和出人意料的结局设计，全网播放量已突破5亿次。',
  },
  {
    date: '2026.07.02',
    title: '「经典重温」专区上线，百部老剧高清修复',
    content: '为满足老剧迷的观看需求，7788电影网推出「经典重温」专区，首批100部经典老剧已完成高清修复，画质焕然一新。',
  },
  {
    date: '2026.06.22',
    title: '移动端适配全面完成，追剧体验更丝滑',
    content: '移动端界面全新改版，针对手机和平板设备进行了深度适配优化，操作更便捷，播放更流畅，随时随地畅享追剧乐趣。',
  },
  {
    date: '2026.06.10',
    title: '《你比星光美丽》豆瓣开分9.4，口碑持续走高',
    content: '都市情感剧《你比星光美丽》豆瓣开分9.4，凭借细腻的情感刻画和演员的出色表演，口碑持续发酵，成为年度现象级热剧。',
  },
];

export const featureItems = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    description: '支持1080P至4K超清画质播放，智能适配网络带宽，确保每一帧画面都清晰锐利，还原导演创作的每一个细节。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    description: '采用全球CDN加速节点与智能预加载技术，大幅降低缓冲等待时间，实现近乎零延迟的流畅播放体验。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量片库',
    description: '收录古装、都市、悬疑、青春等全品类超10万部电视剧资源，既有热门新番，也有经典老剧，满足各种追剧口味。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    description: '与各大平台保持同步更新节奏，新剧上线第一时间入库，追番不落人后，热门剧集更新比快更快。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    description: '全程无弹窗、无插播广告干扰，专注追剧本身。界面简洁清爽，让你沉浸式享受每一集精彩剧情。',
  },
];

export const cardItems = [
  {
    title: '长安十二时辰：一部值得N刷的国产剧巅峰',
    summary: '精良的制作、扎实的剧本、出色的群像表演，让这部剧成为近年来国产古装剧的标杆之作。',
    tag: '编辑力荐',
  },
  {
    title: '都市情感剧的破圈密码：真实感才是王道',
    summary: '《你比星光美丽》成功的背后，是对当代都市人情感状态的真实描摹和深度共情。',
    tag: '深度解读',
  },
  {
    title: '悬疑推理剧为什么越来越受欢迎？',
    summary: '从《深渊行者》的热播看国产悬疑剧的类型进化——剧本为王，反转至上，细节决定成败。',
    tag: '行业观察',
  },
  {
    title: '武侠剧的文艺复兴：传统与创新的融合之路',
    summary: '《山河令之龙渊》用现代视听语言重新诠释武侠精神，为国剧复兴提供了全新思路。',
    tag: '趋势分析',
  },
  {
    title: '青春校园剧二十年：从怀旧到共鸣的进化史',
    summary: '青春剧不再只是怀旧符号，更成为年轻人身份认同与情感释放的重要载体。',
    tag: '专题策划',
  },
  {
    title: '科幻国剧的破冰之旅：《苍穹之下》如何打开新局面',
    summary: '在硬科幻与大众审美之间找到平衡点，国产科幻剧正在走出属于自己的独特道路。',
    tag: '前沿观察',
  },
];

export const faqItems = [
  {
    question: '7788电影网需要注册才能观看吗？',
    answer: '不需要。7788电影网所有电视剧资源均可免费在线观看，无需注册登录。打开网站即可直接搜索和播放您想看的剧集，真正实现即点即看。',
  },
  {
    question: '播放画质可以调整吗？支持哪些清晰度？',
    answer: '可以自由调整。我们支持从流畅480P到超清4K多种画质选择，您可以根据网络状况和观看需求随时切换。系统也会智能推荐最适合当前网络的最佳画质。',
  },
  {
    question: '为什么有些剧集搜索不到？',
    answer: '我们的片库正在持续扩充中，每天都有新剧集入库。如果您想看的剧暂时搜索不到，可以通过联系我们页面提交剧集推荐，我们会优先安排资源收录。',
  },
  {
    question: '支持手机和平板观看吗？',
    answer: '完全支持。7788电影网已针对手机、平板等移动设备进行全面适配优化。您还可以下载我们的移动客户端，享受离线下载、夜间模式等专属功能。',
  },
  {
    question: '播放过程中会插入广告吗？',
    answer: '不会。7788电影网承诺全程无弹窗广告和插播广告，为您提供纯净的追剧体验。观影过程中不会有任何商业信息打扰您的观剧节奏。',
  },
  {
    question: '剧集更新频率是怎样的？',
    answer: '我们与各大视频平台保持同步更新节奏。热门在播剧集通常在上线后24小时内完成同步，部分重点剧集可实现当日同步更新，让您追剧不落后。',
  },
];

export const rankingItems = [
  {
    rank: 1,
    title: '长安十二时辰',
    category: '古装悬疑',
    score: '9.6',
    trend: 'up',
    description: '精良古装巨制，悬疑与历史完美融合',
  },
  {
    rank: 2,
    title: '深渊行者',
    category: '悬疑推理',
    score: '9.5',
    trend: 'up',
    description: '全程高能反转，国产悬疑新标杆',
  },
  {
    rank: 3,
    title: '你比星光美丽',
    category: '都市情感',
    score: '9.4',
    trend: 'up',
    description: '年度现象级都市情感暖心剧',
  },
  {
    rank: 4,
    title: '山河令之龙渊',
    category: '武侠奇幻',
    score: '9.3',
    trend: 'stable',
    description: '武侠复兴之作，特效与剧情俱佳',
  },
  {
    rank: 5,
    title: '那年夏天有风吹过',
    category: '青春校园',
    score: '9.2',
    trend: 'up',
    description: '治愈系青春剧，口碑持续走高',
  },
  {
    rank: 6,
    title: '苍穹之下',
    category: '科幻悬疑',
    score: '9.1',
    trend: 'up',
    description: '科幻国剧新突破，世界观宏大',
  },
  {
    rank: 7,
    title: '锦瑟无端五十弦',
    category: '古装爱情',
    score: '8.9',
    trend: 'new',
    description: '新上榜古装爱情剧，服化道精美',
  },
];

export const footerData = {
  description: '7788电影网是专业的电视剧在线观看平台，提供最新电视剧、热门剧集的高清免费播放服务，追剧首选。',
  sections: [
    {
      title: '剧集分类',
      links: [
        { label: '古装仙侠', href: '#index' },
        { label: '都市情感', href: '#index' },
        { label: '悬疑推理', href: '#index' },
        { label: '青春校园', href: '#index' },
        { label: '历史传奇', href: '#index' },
      ],
    },
    {
      title: '热门推荐',
      links: [
        { label: '热播排行', href: '#ranking' },
        { label: '编辑力荐', href: '#cards' },
        { label: '本周焦点', href: '#carousel' },
        { label: '热门话题', href: '#topics' },
        { label: '最新动态', href: '#updates' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '联系我们', href: '#contact' },
        { label: '常见问题', href: '#faq' },
        { label: '移动追剧', href: '#app' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
    },
  ],
};